export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";